import { render, staticRenderFns } from "./AssetTypes.vue?vue&type=template&id=6fc70676&scoped=true&"
import script from "./AssetTypes.vue?vue&type=script&lang=js&"
export * from "./AssetTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc70676",
  null
  
)

export default component.exports